import React, {Component} from 'react';
import moment from "moment/moment";
import 'moment/locale/tr';

import Select from "../../local_node_modules/react-select"
import '../../local_node_modules/react-select/dist/react-select.css';

import Datetime from "react-datetime/DateTime";
import 'react-datetime/css/react-datetime.css';
import {request} from "../../helper/APIUtils";
import {Col, Input, Row} from 'reactstrap';
import NumberFormat from "react-number-format";


class SearchField extends Component {
    constructor(props) {
        super(props);
        this.state = {
            label: undefined,
            accessor: undefined,
            operator: undefined,
            type: undefined,
            value: '',
            selectData: [],
            oldDate:null,
            isMobile : window.innerWidth > 991 ? false : true
        };

        this.createComponent = this.createComponent.bind(this);
        this.dateComponent = this.dateComponent.bind(this);
        this.dateTimeComponent = this.dateTimeComponent.bind(this);
        this.selectComponent = this.selectComponent.bind(this);
        this.textComponent = this.textComponent.bind(this);
        this.numericTextComponent = this.numericTextComponent.bind(this);
        this.dateComponent = this.dateComponent.bind(this);
        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeTextArea = this.onChangeTextArea.bind(this);
        this.onChangeNumericText = this.onChangeNumericText.bind(this);
        this.onChangeDate = this.onChangeDate.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.getOptions = this.getOptions.bind(this);
        this.onChangeSelect2 = this.onChangeSelect2.bind(this);
        this.isAccessibleDate = this.isAccessibleDate.bind(this);

    }

    componentDidMount() {
        let value = this.props.initialValue;
        let accessor = this.props.accessor;
        let disableInitAccessor = ["min_documentIssueDate","max_documentIssueDate"]
        if(value){
            if(this.props.searchType === "savedSearch"){
                this.setState({value});
                this.props.listener(accessor,value, this.props.type);
            } else if(!(disableInitAccessor.includes(accessor))){
                this.setState({value});
                this.props.listener(accessor,value, this.props.type);
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
       /* if(this.props.searchType !== "savedSearch") {
            this.autoClearDate();
        }*/
    }

    autoClearDate(){
        let self = this;
        let enableInitAccessor = ["min_documentIssueDate","max_documentIssueDate"]
        let accessor = self.props.accessor;
        if(enableInitAccessor.includes(accessor)){
            let value = self.props.initialValue? moment(self.props.initialValue).format("YYYY-MM-DD") : '';
            let oldDate = self.state.oldDate;
            if(value !== oldDate)
            {
                self.setState({oldDate:value});
                this.props.listener(accessor,'');
            }
        }

    }

    isAccessibleDate(selected){
        let self = this;
        if(self.props.disableAccessibleDate)
            return true;
        let date = self.props.initialValue;
        if(date){
            const lastDay = moment(date).endOf('month').format("YYYY-MM-DD")
            const firstDay = moment(date).startOf('month').format("YYYY-MM-DD")
            return  selected.isBetween(firstDay,lastDay,undefined, '[]');
        }
        else
            return true;
    }

    dateComponent() {
        let dateValue = this.state.value;
        return (
            <Datetime locale="tr"
                      className="datepicker"
                      input={true}
                      closeOnSelect={true}
                      viewDate={this.props.initialValue? this.props.initialValue:new moment()}
                      value={moment(dateValue, "YYYY-MM-DD", true).isValid() ? moment(dateValue).format("DD-MM-YYYY") : dateValue}
                      dateFormat="DD-MM-YYYY"
                      isValidDate={this.isAccessibleDate}
                      inputProps={{ placeholder: 'GG-AA-YYYY'}}
                      timeFormat={false}
                      onBlur={(e) => {
                          if(!moment(e, "DD-MM-YYYY", true).isValid() && !moment(e, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
                              this.onChangeDate(this.props.initialValue? this.props.initialValue : new moment(), "date", this.props.accessor);
                          }}}
                      onChange={(e) => {
                          if(moment(e, "DD-MM-YYYY HH:mm:ss", true).isValid() || moment(e, "DD-MM-YYYY", true).isValid()) {
                              this.onChangeDate(e, "date", this.props.accessor);
                          }}}/>
        )
    }

    dateTimeComponent(type) {
        const {isMobile} = this.state;
        let dateValue = this.state.value;
        return (
            <Datetime locale="tr"
                      className="datepicker"
                      input={true}
                      closeOnSelect={true}
                      value={moment(dateValue, "YYYY-MM-DD HH:mm:ss", true).isValid()  ? moment(dateValue).format("DD-MM-YYYY") : dateValue}
                      dateFormat="DD-MM-YYYY"
                      timeFormat="HH:mm:ss"
                      inputProps={{ placeholder: 'GG-AA-YYYY',readOnly: isMobile ? true : false}}
                      onBlur={(e) => {
                          if(!moment(e, "DD-MM-YYYY", true).isValid() && !moment(e, "DD-MM-YYYY HH:mm:ss", true).isValid()) {
                              if((e.length === 0))
                                  this.onChangeDate(e,"",this.props.accessor)
                              /*else
                                  this.onChangeDate(new moment(), "datetime", this.props.accessor);*/
                          }}}
                      onChange={(e) => {
                          if(moment(e, "DD-MM-YYYY HH:mm:ss", true).isValid() || moment(e, "DD-MM-YYYY", true).isValid()) {
                              if (type === "timestamp"){
                                this.onChangeDate(e, type, this.props.accessor);
                              }else {
                                  this.onChangeDate(e, type, this.props.accessor);
                              }
                          }
                          if(e.length === 0)
                              this.onChangeDate(e,"",this.props.accessor)
                      }}
            />

        )
    }

    monthComponent() {
        let dateValue = this.state.value;
        return (
            <Datetime locale="tr"
                      className="datepicker"
                      input={true}
                      closeOnSelect={true}
                      value={moment(dateValue, "YYYY-MM-DD HH:mm:ss", true).isValid() ? moment(dateValue).format("YYYY/MM") : dateValue}
                      dateFormat="MM/YYYY"
                      timeFormat={false}
                      onChange={(e) => this.onChangeDate(e, "month", this.props.accessor)}/>
        )
    }

    optionClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
    }

    selectedBadgeClicked(optionsList) {
        this.setState({ multiSelect: optionsList });
    }

    selectComponent() {
        return (
            <Select
                // className='selectpicker'
                type='select'
                // multiple
                value={this.state.value}
                clearable={false}
                noResultsText="Veri yok"
                clearValueText="Temizle"
                placeholder="Seçiniz..."
                onChange={(e) => this.onChangeSelect(e, this.props.accessor)}
                options={this.props.selectData}
                // options= {this.props.selectData.map((data) => ({
                //   value: data
                // }))}
                //{this.props.selectData.map((data) => <option value={data.value}>{data.label}</option>)}</Select>
            />
        )
    }

    select2Component() {
        return (
            <Select.Async
                type='select'
                value={{
                    value: this.state.value,
                    label: this.state.value
                }}
                clearable={true}
                clearValueText="Temizle"
                placeholder="Aranacak Kelime Giriniz"
                noResultsText="Kayıt bulunamadı."
                searchPromptText="Arama için en az 3 karakter giriniz."
                loadingPlaceholder="Yükleniyor..."
                onChange={(e) => this.onChangeSelect2(e, this.props.accessor)}
                loadOptions={this.getOptions}
            />
        )
    }

    getOptions (input) {
         if(this.props.path && input && input.length>2){
            let params = {
                url: this.props.path,
                method: "post",
                data: {
                    searchKey: input,
                }
            };
            return request(params)
                .then((response) => {
                    return response.data;
                 }).then((data) => {
                    return { options: data };
                });
         }else{
             return Promise.resolve({ options: [] }); ;
         }
    }

    textComponent(handleKeyPress) {
        return (
            <input className="form-control"
                   type="text"
                   onKeyPress={handleKeyPress}
                   value={this.state.value}
                   onChange={(e) => this.onChangeText(e, this.props.accessor)}/>
        )
    }

    textAreaComponent(handleKeyPress){
        return(
            <textarea
                className="form-control"
                data-vlength="0,2000"
                pattern="[^0-9,]"
                style={{width:'100%', paddingBottom:'inherit', border: "1px solid rgba(151, 151, 151, 0.65)",
                    borderRadius: "3px", paddingTop: '7px'}}
                value={this.state.value}
                onKeyPress={handleKeyPress}
                onKeyUp={(e) => this.onKeyUpTextArea(e)}
                onChange={(e) => this.onChangeTextArea(e, this.props.accessor)}
                rows="3"
            />
        )
    }

    numericTextComponent(handleKeyPress) {
        return (
            <input className="form-control"
                   type="text"
                   pattern="[0-9\s]*"
                   value={this.state.value}
                   onKeyPress={handleKeyPress}
                   maxLength={11}
                   onChange={(e) => this.onChangeNumericText(e, this.props.accessor)}/>
        )
    }

    decimalTextComponent(handleKeyPress) {
        return (
            <NumberFormat
                          value={this.state.value}
                          allowNegative={false}
                          isNumericString={true}
                          allowEmptyFormatting={false}
                          decimalScale={9}
                          thousandSeparator={'.'}
                          decimalSeparator={','}
                          displayType="input"
                          placeholder=""
                          onKeyPress={handleKeyPress}
                          renderText={value => {
                              value.replace(/\./g, ',')
                          }}
                          onValueChange={(e) => this.onChangeDecimalText(e, this.props.accessor)}
                          className="form-control"/>
        )
    }

    /********** EVENT HANDLERS ****/

    onChangeSelect(e, fieldName) {

        if (!e) return

        this.setState({value: e.value})

        this.props.listener(fieldName, e.value, this.props.type)

    }

    onChangeSelect2(e, fieldName) {
        let value;
        if(e)
            value=e.value;
        else
            value=null;

        this.setState({value: value});
        this.props.listener(fieldName, value);
    }

    onChangeText(e, fieldName) {
        if (!e) return;

        this.setState({value: e.target.value})

        this.props.listener(fieldName, e.target.value)

    }

    onChangeTextArea(e, fieldName) {
        if (!e)
            return;

        if(!new RegExp(/^[0-9\s|\,]*$/g).test(e.target.value))
            e.target.value = "";

        this.setState({value: e.target.value});
        this.props.listener(fieldName, e.target.value, this.props.type);

    }

    onKeyUpTextArea(e) {
        let lines = e.target.value.split(',');
        e.target.value = lines.slice(0, 9).join(',');
        if (new RegExp(/^[0-9\s|\,]*$/g).test(e.target.value)) {
            return e.target.value;
        } else {
            lines.pop();
            e.target.value = lines.slice(0, 9).join(' ');
            return e.target.value;
        }
    }

    onChangeNumericText(e, fieldName) {

        if (!e) return;
        if (!e.target.validity.valid) {
            return;
        }

        let value = e.target.value.replace(/ /g, '');

        this.setState({value: value})

        this.props.listener(fieldName, value)

    }

    onChangeDecimalText(e, fieldName){
        let value = e.value;
        this.setState({value});
        this.props.listener(fieldName, value);
    }

    onChangeDate(momentObj, type, fieldValue) {
        let value;
        if (!(typeof momentObj === "string")) {

            if (type === "date") {
                value = momentObj.format("YYYY-MM-DD");
                this.setState({value});
            } else if (type === "datetime") {
                value = momentObj.format("YYYY-MM-DD HH:mm:ss");
                this.setState({value})
            } else if (type === "month") {
                value = momentObj.format("YYYY-MM-DD HH:mm:ss");
                this.setState({value});
            } else if (type === "timestamp") {
                value = momentObj;
                this.setState({value});
            }
        } else {
            if(momentObj.length === 0){
                value = undefined;
            }
            value = momentObj;
            if (type === "datetime" && moment(value, "DD-MM-YYYY", true).isValid()) {
                value = moment(value, "DD-MM-YYYY", true).format("YYYY-MM-DD HH:mm:ss");
            }
            this.setState({value})
        }
        this.props.listener(fieldValue, value, type)
    }


    render() {
        return (

            <Row style={{padding: '2px 2%'}}>
                <Col sm='5' className='col-form-label' style={{textAlign: 'end'}}>
                    {
                        this.props.label
                    }
                </Col>

                <Col sm='7'>

                    {
                        this.props.type &&
                        this.createComponent(this.props.type, this.props.operator)
                    }
                </Col>
            </Row>

        )
    }


    /**** COMPONENT HANDLER ***/


    createComponent(type, operator) {
        if (type === "select") {
            return this.selectComponent();
        }if (type === "select2") {
            return this.select2Component();
        } else if (type === "date") {
            return this.dateComponent();
        } else if (type === "datetime" || type === "timestamp") {
            return this.dateTimeComponent(type);
        } else if (type === "month") {
            return this.monthComponent();
        } else if (type === "text") {
            return this.textComponent(this.props.onKeyPress);
        } else if (type === "numericText") {
            return this.numericTextComponent(this.props.onKeyPress);
        } else if (type ==="decimalText"){
          return this.decimalTextComponent(this.props.onKeyPress);
        } else if(type ==="textArea"){
            return this.textAreaComponent(this.props.onKeyPress);
        } else {
            return null;
        }
    }


}


export default SearchField;